import { css } from 'styled-components'

export const containerStyle = css`
	height: 100%;
	padding: 24px;
	> div {
		max-width: 300px;
	}
`
